import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "../features/auth/Login";
import Motoristas from "../features/motoristas/Motoristas";
import Reservas from "../features/reservas/Reservas";
import Roteirizador from "../features/roteirizador/Roteirizador";
import Pedidos from "../features/pedidos/Pedidos";
import Instalacoes from "../features/instalacoes/Instalacoes";
import { MainLayout } from "./MainLayout";
import { RequireAuth } from "./RequireAuth";

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    ),
    children: [
      // Pagina default igual ao baseline anterior ao refactor.
      { index: true, element: <Navigate to="/motoristas" replace /> },
      { path: "motoristas", element: <Motoristas /> },
      { path: "reservas", element: <Reservas /> },
      { path: "roteirizador", element: <Roteirizador /> },
      { path: "pedidos", element: <Pedidos /> },
      { path: "pedidos/:pedidoId", element: <Pedidos /> },
      { path: "instalacoes", element: <Instalacoes /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
